<template>
  <v-fade-transition mode="out-in">
    <!-- List -->
    <Flipper v-if="items.length > 0" :flipKey="flipKey">
      <v-list-item-group color="primary">
        <v-fade-transition group>
          <Flipped v-for="item in items" :key="'item' + item.uuid" :flipId="'item' + item.uuid">
            <div>
              <CompareLoansItem :item="item" />
            </div>
          </Flipped>
        </v-fade-transition>
      </v-list-item-group>
    </Flipper>

    <!-- loading -->
    <v-layout
      v-else-if="loading"
      style="height: 400px"
      justify-center
      fill-height
      align-center
      column
    >
      <v-progress-circular indeterminate color="grey" class="mb-1" size="30"></v-progress-circular>
      <p class="mt-2 color--nice-grey text-center">
        이용 가능한 사업자 신용 대출을<br />불러오고 있습니다.
      </p>
    </v-layout>

    <!-- no-data -->
    <v-layout v-else style="height: 400px" justify-center fill-height align-center column>
      <v-btn outlined fab disabled x-small>
        <v-icon size="20">mdi-exclamation</v-icon>
      </v-btn>
      <p class="mt-2 color--nice-grey">이용 가능한 사업자 신용 대출이 없습니다.</p>
    </v-layout>
  </v-fade-transition>
</template>

<script>
import { Flipper, Flipped } from 'vue-flip-toolkit'

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Flipper,
    Flipped,
    CompareLoansItem: () => import('@/components/compare-loans/CompareLoansItem.vue'),
  },

  computed: {
    flipKey() {
      return this.items.map((item) => item.uuid).join('-')
    },
  },
}
</script>

<style lang="scss" scoped></style>
